/**
 * API 설정 파일
 * 환경 변수에서 API Base URL을 읽어옵니다.
 * 
 * 환경 변수 우선순위:
 * 1. .env.local (로컬 개발용, 최우선)
 * 2. .env.development (개발 서버용)
 * 3. .env.production (프로덕션용)
 * 4. .env (기본값)
 */

// Vite 환경 변수에서 API Base URL 가져오기
// VITE_ 접두사가 붙은 환경 변수만 클라이언트에서 접근 가능
const getApiBaseUrl = (): string => {
  // 환경 변수가 설정되어 있으면 사용, 없으면 기본값 사용
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  
  if (baseUrl) {
    return baseUrl;
  }
  
  // 환경 변수가 없을 경우 기본값 (개발 서버)
  console.warn('VITE_API_BASE_URL이 설정되지 않았습니다. 기본값을 사용합니다.');
  return 'http://dev.exceedplatform.com:8080';
};

// API Base URL 내보내기
export const API_BASE_URL = getApiBaseUrl();

// API 엔드포인트 헬퍼 함수
export const getApiUrl = (endpoint: string): string => {
  // endpoint가 이미 전체 URL인 경우 그대로 반환
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
    return endpoint;
  }
  
  // endpoint가 /로 시작하지 않으면 추가
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  // Base URL의 마지막이 /로 끝나면 제거
  const normalizedBaseUrl = API_BASE_URL.endsWith('/') 
    ? API_BASE_URL.slice(0, -1) 
    : API_BASE_URL;
  
  return `${normalizedBaseUrl}${normalizedEndpoint}`;
};

// API v1 엔드포인트 헬퍼 함수
export const getApiV1Url = (endpoint: string): string => {
  return getApiUrl(`/api/v1${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`);
};

// 개발 모드 확인
export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;

/** 운영 CDN 베이스 URL (예: https://cdn.example.com) */
export const getCdnBaseUrl = (): string | null => {
  const cdnUrl = import.meta.env.VITE_CDN_BASE_URL;
  if (!cdnUrl || typeof cdnUrl !== 'string') {
    return null;
  }
  return cdnUrl.endsWith('/') ? cdnUrl.slice(0, -1) : cdnUrl;
};

// 디버그 정보 출력 (개발 모드에서만)
if (isDevelopment) {
  console.log('API 설정:', {
    baseUrl: API_BASE_URL,
    mode: import.meta.env.MODE,
    isDev: isDevelopment,
    isProd: isProduction
  });
}

